module.exports = __webpack_public_path__ + "static/008436-e668cdb5c551674b899c45f65308335b.jpg";